// Layout and spacing constants
export const LAYOUT = {
  MAX_WIDTH: 'max-w-6xl',
  CONTAINER_PADDING: 'py-8 px-4',
  SECTION_SPACING: 'space-y-8',
  GRID_COLS: {
    ACTIVITIES: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
    TEAMS: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3'
  }
} as const

// Team configuration constants
export const TEAM_CONFIG = {
  DEFAULT_MAX_PARTICIPANTS: 4,
  MIN_PARTICIPANTS_FOR_VALIDATION: 3,
  TEAM_NAMES: ['Alpha', 'Beta', 'Gamma', 'Delta', 'Epsilon', 'Zeta', 'Eta', 'Theta', 'Iota', 'Kappa']
} as const

// Activity configuration constants
export const ACTIVITY_CONFIG = {
  DEFAULT_LIMITS: {
    INTRODUCTION: 1,
    FIRST_GAME_SESSION: 1,
    SHORT_GAME_SESSION: null, // unlimited
    LONG_GAME_SESSION: null, // unlimited
    GROUP_REFLECTION: null // unlimited
  }
} as const

// Drag and drop constants
export const DRAG_DROP = {
  Z_INDEX: {
    OVERLAY: 50,
    DOTTED_LINE: 0,
    ACTIVITY_CARD: 10
  }
} as const

// Date and time formatting constants
export const DATE_TIME = {
  DATE_FORMAT_OPTIONS: {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  } as Intl.DateTimeFormatOptions,
  TIME_FORMAT_24_TO_12: {
    0: 12,
    13: 1,
    14: 2,
    15: 3,
    16: 4,
    17: 5,
    18: 6,
    19: 7,
    20: 8,
    21: 9,
    22: 10,
    23: 11
  }
} as const

// Export sprint configuration constants
export * from './activities'
